// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2ZxcL","calendarButtons":"ClockData_calendarButtons__3R410"};